import { render, staticRenderFns } from "./TransactionItem.vue?vue&type=template&id=623e1218&scoped=true&"
import script from "./TransactionItem.vue?vue&type=script&lang=js&"
export * from "./TransactionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e1218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623e1218')) {
      api.createRecord('623e1218', component.options)
    } else {
      api.reload('623e1218', component.options)
    }
    module.hot.accept("./TransactionItem.vue?vue&type=template&id=623e1218&scoped=true&", function () {
      api.rerender('623e1218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Account/TransactionItem.vue"
export default component.exports